export const setItem = (key: string, item: unknown): void => {
  if (typeof localStorage === 'undefined') {
    return;
  }

  localStorage.setItem(key, typeof item === 'string' ? item : JSON.stringify(item));
};

export const getItem = <T>(key: string): T | null => {
  if (typeof localStorage === 'undefined') {
    return null;
  }
  const item = localStorage.getItem(key);

  return (item && JSON.parse(item)) as T | null;
};

export const removeItem = (key: string): void => localStorage.removeItem(key);
